import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center font-sourcesanspro-semibold text-lg24 mr-2"
}
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "mr-2" }
const _hoisted_6 = { class: "font-sourcesanspro-semibold text-l2 capitalize" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "flex items-center justify-center" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-center mr-2"
}
const _hoisted_11 = { class: "font-sourcesanspro-bold text-sm text-white/30 line-through" }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center justify-center mr-2 px-3 py-[1px] rounded-full bg-anykrowd-discount-green font-sourcesanspro-bold text-xs2"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "font-sourcesanspro-bold text-base2 text-white" }
const _hoisted_16 = { class: "flex items-center justify-between w-[100px]" }
const _hoisted_17 = { class: "font-sourcesanspro-semibold text-lg" }
const _hoisted_18 = {
  key: 0,
  class: "px-5 pb-4 font-sourcesanspro-regular text-sm text-white/50",
  slot: "content"
}
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_21 = { class: "flex w-full items-center justify-start text-white rounded" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "font-sourcesanspro-regular text-sm text-[#1C1725]/50 max-w-[90%]" }

import { PropType, ref, watch } from 'vue';
import { IonAccordionGroup, IonAccordion, IonButton, IonIcon } from '@ionic/vue';
import { addOutline, chevronDownOutline, chevronUpOutline, createOutline, removeOutline, trashOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import { Discount, DiscountType } from '@/shared/interfaces/discount';
import useTenant from '@/shared/composables/useTenant';
import useToast from '@/shared/composables/useToast';
import { Currency } from '@/shared/interfaces/balance';
import { EventTicketType } from '@/shared/interfaces/eventTicketType';
import { EventComboTicketType } from '@/shared/interfaces/eventComboTicketType';
import { Product } from '@/shared/interfaces/tableSpot';
import { GenericProduct } from '@/shared/interfaces/genericProduct';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ItemAdder',
  props: {
	addMoreError: { type: String, default: '' },
	addMoreErrorDetail: { type: String, default: '' },
	canAddMore: { type: Boolean, default: false },
	canWriteAComment: { type: Boolean, default: false },
	class: { type: String },
	description: { type: String },
	discount: { type: Discount },
	expandable: { type: Boolean, default: true },
	id: { type: Number },
	startExpanded: { type: Boolean, default: true },
	comments: {
		type: Object as PropType<string[]>,
		required: false,
	},
	price: { type: Number, required: true },
	priceWithDiscount: { type: Number },
	currency: { type: Currency, required: true },
	productId: { type: Number, required: true },
	product: {
		type: Object as PropType<EventTicketType | EventComboTicketType | Product | GenericProduct>,
		required: true,
	},
	quantity: { type: Number, required: true },
	title: { type: String, required: true },
},
  emits: ['onWriteAComment', 'onDecreaseProductQuantity', 'onIncreaseProductQuantity', 'onDeleteAComment'],
  setup(__props, { emit: __emit }) {

const props = __props;

// Init
const { t } = useI18n();
const isOpen = ref(props.startExpanded);
const emit = __emit;
const { presentToast } = useToast();
const { getTenantConfigAndStyles } = useTenant();
const accordionValue = ref<string | undefined>(props.startExpanded && props.description ? props.id?.toString() : undefined);

// deleteComment
const deleteComment = (commentIndex: number) => {
	emit('onDeleteAComment', props.productId, commentIndex);
};

// writeAComment
const writeAComment = () => {
	emit('onWriteAComment');
};

// decreaseProductQuantity
const decreaseProductQuantity = (event: MouseEvent) => {
	event.stopPropagation();
	emit('onDecreaseProductQuantity', props.product);
};

// increaseProductQuantity
const increaseProductQuantity = (event: MouseEvent) => {
	event.stopPropagation();
	emit('onIncreaseProductQuantity', props.product);
};

watch(accordionValue, () => {
	isOpen.value = !isOpen.value;
});

const toggleAccordion = () => {
	accordionValue.value = isOpen.value ? undefined : props.id?.toString();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordionGroup), {
    modelValue: accordionValue.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accordionValue).value = $event)),
    class: _normalizeClass(props.class)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordion), {
        class: "backdrop-blur-xl bg-white/10 rounded-lg",
        value: props.description ? _ctx.$props.id?.toString() : ''
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex flex-col w-full justify-between px-3 py-2 cursor-pointer",
            slot: "header",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.expandable ? toggleAccordion() : null))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (__props.expandable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(IonIcon), {
                        icon: isOpen.value ? _unref(chevronUpOutline) : _unref(chevronDownOutline),
                        class: "text-white"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(props.title?.toLowerCase()), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: _normalizeClass(["font-sourcesanspro-bold text-lg", [{ 'text-white/30': props.quantity === 0 }]])
                }, _toDisplayString(props.currency?.prefix) + " " + _toDisplayString(((props.discount ? props.priceWithDiscount : props.price)! * props.quantity!).toFixed(2)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (props.discount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(props.currency?.prefix) + _toDisplayString(props.price.toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (props.discount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (props.discount.type === _unref(DiscountType).FIXED)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("span", null, _toDisplayString(props.currency?.prefix) + " " + _toDisplayString(props.discount.amount.toFixed(2)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (props.discount.type === _unref(DiscountType).PERCENTAGE)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(props.discount.amount) + " %", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_15, _toDisplayString(props.currency?.prefix) + " " + _toDisplayString(props.discount ? props.priceWithDiscount?.toFixed(2) : props.price.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createVNode(_unref(IonButton), {
                    class: "w-[32px] h-[32px] ion-no-padding ion-no-margin",
                    fill: "outline",
                    style: {"z-index":"1000"},
                    onClick: _cache[0] || (_cache[0] = (event) => decreaseProductQuantity(event)),
                    disabled: __props.quantity === 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(removeOutline),
                        class: "text-white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("span", _hoisted_17, _toDisplayString(props.quantity), 1),
                _createElementVNode("div", null, [
                  _createVNode(_unref(IonButton), {
                    class: _normalizeClass(["w-[32px] h-[32px] ion-no-padding ion-no-margin hover:rounded", [
									{
										'hover:bg-white': __props.canAddMore,
										'no-more-items': !__props.canAddMore,
									},
								]]),
                    onClick: _cache[1] || (_cache[1] = (event) => increaseProductQuantity(event)),
                    disabled: !__props.canAddMore
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(addOutline),
                        class: "text-anykrowd-dark"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"])
                ])
              ])
            ])
          ]),
          (__props.expandable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(props.description), 1),
                (props.canWriteAComment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_unref(IonButton), {
                        disabled: props.quantity === 0,
                        class: "flex justify-left w-full comment",
                        fill: "outline",
                        onClick: writeAComment
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(createOutline),
                              class: "mr-2"
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('form.write_a_comment')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.comments, (comment, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "flex items-center justify-between mb-1 px-3 py-2 bg-white rounded-md"
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(comment), 1),
                    _createVNode(_unref(IonButton), {
                      class: "w-[35px] h-[35px] ion-no-padding ion-no-margin transparent",
                      onClick: ($event: any) => (deleteComment(idx))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(trashOutline),
                          class: "text-sm text-anykrowd-dark"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})